import { ModuleWithProviders, NgModule } from '@angular/core';

@NgModule()
export class I2gNgUtilsModule {
  static forRoot(): ModuleWithProviders<I2gNgUtilsModule> {
    return {
      ngModule: I2gNgUtilsModule,
    };
  }
}
